import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = 'ri-film-line',
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex w-full flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
        <i className={`${icon} text-3xl`} aria-hidden="true" />
      </div>
      <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{title}</h3>
      {description && (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}